(function () {
  if (window.__tmrSwipeInit) return;
  window.__tmrSwipeInit = true;

  const ACT = 'product-card__dot--active';
  const TRANSITION = 'transform 420ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  const isCoarsePointer = () => window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  const isFinePointer = () => window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  const bumpFigHover = (figure) => {
    if (!figure) return 0;
    figure._tmrHoverGen = (figure._tmrHoverGen | 0) + 1;
    return figure._tmrHoverGen;
  };
  const figHoverOk = (figure, gen) => figure && (figure._tmrHoverGen | 0) === gen;

  const imgPreloadCache = new Map();
  window.__tmrPreloadUrl = (url) => {
    if (!url) return Promise.resolve();
    if (imgPreloadCache.has(url)) return imgPreloadCache.get(url);
    const p = new Promise((resolve) => {
      const im = new Image();
      im.onload = im.onerror = () => resolve();
      im.src = url;
    });
    imgPreloadCache.set(url, p);
    return p;
  };

  const markSwipeImgReady = (img) => {
    if (!img) return;
    const done = () => {
      try {
        img.classList.add('tmr-img-ready');
      } catch (_) {}
    };
    if (img.complete && img.naturalWidth > 0) done();
    else img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  };

  /** Shared PLP swipe image warm-up (used by swatch rebuild + initTrack + viewport IO). */
  window.__tmrPrimeSwipeTrackImages =
    window.__tmrPrimeSwipeTrackImages ||
    function (trackEl) {
      if (!trackEl) return Promise.resolve();
      const imgs = Array.from(trackEl.querySelectorAll('img'));
      return Promise.all(
        imgs.map((img) => {
          try {
            if (img.loading === 'lazy') img.loading = 'eager';
          } catch (_) {}
          const decode = () => (img.decode ? img.decode().catch(() => {}) : Promise.resolve());
          if (img.complete && img.naturalWidth > 0) return decode();
          return new Promise((resolve) => {
            const done = () => resolve();
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          }).then(decode);
        })
      );
    };

  function initTrack(track) {
    if (track.dataset.tmrSwipe) return;
    track.dataset.tmrSwipe = '1';

    const card = track.closest('.product-card__swipe');
    if (!card) return;

    // Disable card carousel inside PDP rails only (Related + Recently Viewed).
    // Those rails have their own horizontal drag and the card swipe conflicts with it.
    if (track.closest('.shopify-section--related-products, .shopify-section--recently-viewed-products')) {
      card.dataset.tmrSwipeDisabled = '1';
      return;
    }

    const dots = Array.from(card.querySelectorAll('.product-card__dot'));
    const realSlides = Array.from(track.children);
    const realCount = realSlides.length;
    if (realCount < 2) return;

    // Hermès-style seamless loop: clone last -> front, clone first -> end.
    const firstClone = realSlides[0].cloneNode(true);
    const lastClone = realSlides[realCount - 1].cloneNode(true);
    [firstClone, lastClone].forEach((c) => {
      c.dataset.clone = '1';
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
    });
    track.insertBefore(lastClone, realSlides[0]);
    track.appendChild(firstClone);

    // Slides keep their own loading attribute (slide 1 eager, the rest lazy). Off-screen cards' slides are
    // loaded by swipePrimeIO when the card comes near the viewport, or on hover / arrow focus / swipe.
    track.querySelectorAll('img').forEach((img) => {
      markSwipeImgReady(img);
    });

    // Index space: 0 = lastClone, 1..realCount = real slides, realCount+1 = firstClone
    let currentIndex = 1;
    let transitionEndTimer = 0;
    let onTransitionEnd = null;

    function clearAnimationState() {
      if (transitionEndTimer) {
        clearTimeout(transitionEndTimer);
        transitionEndTimer = 0;
      }
      if (onTransitionEnd) {
        track.removeEventListener('transitionend', onTransitionEnd);
        onTransitionEnd = null;
      }
    }

    function slideWidth() {
      const first = track.firstElementChild;
      if (first) {
        const w = first.getBoundingClientRect().width;
        if (w > 0) return w;
      }
      const viewport = track.closest('.product-card__swipe-viewport');
      const ref = viewport || card;
      const cw = ref.getBoundingClientRect().width;
      if (cw > 0) return cw;
      return 0;
    }

    function setActiveDotFromIndex(idx) {
      if (!dots.length) return;
      const realIdx = idx === 0 ? (realCount - 1) : (idx === realCount + 1 ? 0 : (idx - 1));
      dots.forEach((d, i) => d.classList.toggle(ACT, i === realIdx));
    }

    // Mobile dots: show 4 by default, reveal all after first horizontal swipe on this card.
    let dotsRevealed = card.dataset.tmrDotsRevealed === '1';
    function applyDotsLimit() {
      if (!isCoarsePointer()) return;
      if (dotsRevealed) return;
      if (dots.length <= 4) return;
      dots.forEach((d, i) => {
        d.hidden = i >= 4;
      });
    }
    function revealAllDots() {
      if (dotsRevealed) return;
      dotsRevealed = true;
      try {
        card.dataset.tmrDotsRevealed = '1';
      } catch (_) {}
      dots.forEach((d) => (d.hidden = false));
    }
    applyDotsLimit();

    let slideWidthRafDepth = 0;
    const MAX_SLIDE_WIDTH_RAFS = 40;
    function setIndexTransform(idx, animate) {
      let w = slideWidth();
      if (w <= 0) {
        if (slideWidthRafDepth < MAX_SLIDE_WIDTH_RAFS) {
          slideWidthRafDepth += 1;
          requestAnimationFrame(() => setIndexTransform(idx, animate));
          return;
        }
        slideWidthRafDepth = 0;
        w = Math.max(1, Math.round(card.getBoundingClientRect().width || 0));
        if (w <= 1) return;
      } else {
        slideWidthRafDepth = 0;
      }
      const px = -(idx * w);
      track.style.transition = animate ? TRANSITION : 'none';
      track.style.transform = `translate3d(${px}px, 0, 0)`;
    }

    function snapSilently() {
      clearAnimationState();
      setIndexTransform(currentIndex, false);
      // If we are on a clone, teleport to the matching real slide.
      if (currentIndex === 0) {
        currentIndex = realCount;
        setIndexTransform(currentIndex, false);
      } else if (currentIndex === realCount + 1) {
        currentIndex = 1;
        setIndexTransform(currentIndex, false);
      }
      setActiveDotFromIndex(currentIndex);
    }

    // Move by delta in *real slide space*, using clones only at boundaries.
    function goBy(delta) {
      const realIdx =
        currentIndex === 0 ? (realCount - 1) :
        (currentIndex === realCount + 1 ? 0 : (currentIndex - 1));

      const nextReal = (realIdx + delta + realCount) % realCount;

      // Animate into clones only when crossing the edges.
      if (delta > 0 && realIdx === realCount - 1) {
        goTo(realCount + 1); // firstClone
      } else if (delta < 0 && realIdx === 0) {
        goTo(0); // lastClone
      } else {
        goTo(nextReal + 1);
      }
    }

    function goTo(idx) {
      clearAnimationState();
      currentIndex = idx;
      setIndexTransform(currentIndex, true);
      setActiveDotFromIndex(currentIndex);

      const finish = () => {
        clearAnimationState();
        if (currentIndex === 0) {
          currentIndex = realCount;
          setIndexTransform(currentIndex, false);
        } else if (currentIndex === realCount + 1) {
          currentIndex = 1;
          setIndexTransform(currentIndex, false);
        }
        setActiveDotFromIndex(currentIndex);
      };

      onTransitionEnd = (e) => {
        if (e.target !== track) return;
        if (e.propertyName && e.propertyName !== 'transform') return;
        finish();
      };
      track.addEventListener('transitionend', onTransitionEnd);
      transitionEndTimer = window.setTimeout(finish, 480);
    }

    // Desktop: 2nd image only while hovering the figure (image). Leaving for swatches or off-card
    // resets to slide 1 immediately — no fade delay.
    const figure = card.closest('.product-card__figure');
    if (figure) {
      try {
        figure._tmrFigureHoverAbort?.abort();
      } catch (_) {}
      figure._tmrFigureHoverAbort = new AbortController();
      const figSig = figure._tmrFigureHoverAbort.signal;
      let hoverEnterTimer = 0;

      const resetToFirstSlide = () => {
        if (hoverEnterTimer) {
          clearTimeout(hoverEnterTimer);
          hoverEnterTimer = 0;
        }
        bumpFigHover(figure);
        figure.classList.remove('tmr-plp-swipe-hover-ready');
        clearAnimationState();
        currentIndex = 1;
        snapSilently();
      };

      figure.addEventListener(
        'tmr:swatches-expand',
        resetToFirstSlide,
        { signal: figSig }
      );
      figure.addEventListener(
        'tmr:plp-variant-change',
        resetToFirstSlide,
        { signal: figSig }
      );

      if (isFinePointer()) {
        figure.addEventListener(
          'mouseenter',
          () => {
            if (realCount <= 1) return;
            try {
              figure.classList.remove('tmr-plp-swatch-changed');
            } catch (_) {}
            if (hoverEnterTimer) {
              clearTimeout(hoverEnterTimer);
              hoverEnterTimer = 0;
            }
            figure.classList.remove('tmr-plp-swipe-hover-ready');
            const gen = bumpFigHover(figure);
            const targetIdx = realCount >= 2 ? 2 : 1;
            let settled = false;
            const finish = () => {
              if (settled || !figHoverOk(figure, gen)) return;
              settled = true;
              if (hoverEnterTimer) {
                clearTimeout(hoverEnterTimer);
                hoverEnterTimer = 0;
              }
              currentIndex = targetIdx;
              snapSilently();
              if (!figHoverOk(figure, gen)) return;
              figure.classList.add('tmr-plp-swipe-hover-ready');
            };
            hoverEnterTimer = window.setTimeout(finish, 220);
            const p = window.__tmrPrimeSwipeTrackImages?.(track);
            if (p && typeof p.then === 'function') {
              p.then(finish, finish);
            } else {
              queueMicrotask(finish);
            }
          },
          { signal: figSig }
        );
        figure.addEventListener(
          'mouseleave',
          (e) => {
            if (e.relatedTarget && figure.contains(e.relatedTarget)) return;
            const cardEl = figure.closest('product-card');
            const swatchRoot = cardEl?.querySelector?.('[data-tmr-card-swatches="1"]');
            if (e.relatedTarget && swatchRoot?.contains(e.relatedTarget)) {
              resetToFirstSlide();
              return;
            }
            if (e.relatedTarget && cardEl?.contains(e.relatedTarget)) return;
            resetToFirstSlide();
          },
          { signal: figSig }
        );
      }
    }

    const prevBtn = card.querySelector('.product-card__swipe-arrow--prev');
    const nextBtn = card.querySelector('.product-card__swipe-arrow--next');
    if (prevBtn && !prevBtn.dataset.tmrSwipeArrow) {
      prevBtn.dataset.tmrSwipeArrow = '1';
      const blockNav = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      };
      prevBtn.addEventListener('pointerdown', blockNav, { capture: true });
      prevBtn.addEventListener('mousedown', blockNav, { capture: true });
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        goBy(-1);
      }, { capture: true });
    }
    if (nextBtn && !nextBtn.dataset.tmrSwipeArrow) {
      nextBtn.dataset.tmrSwipeArrow = '1';
      const blockNav = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      };
      nextBtn.addEventListener('pointerdown', blockNav, { capture: true });
      nextBtn.addEventListener('mousedown', blockNav, { capture: true });
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        goBy(1);
      }, { capture: true });
    }

    // Initial alignment (mobile visible immediately; desktop aligns on hover via rAF).
    snapSilently();

    // Mobile: no scroll-snap / no momentum → transform drag → snap exactly one slide.
    if (isCoarsePointer()) {
      let startX = 0, startY = 0, baseX = 0;
      let startT = 0;
      let lastX = 0;
      let lastT = 0;
      let velocityX = 0;
      let dragging = false;
      let locked = null; // 'x' | 'y' | null
      let moved = false;
      let raf = 0;
      let pendingX = 0;

      const setXPixels = (px) => {
        track.style.transition = 'none';
        track.style.transform = `translate3d(${px}px, 0, 0)`;
      };

      const getCurrentTranslateX = () => {
        const t = getComputedStyle(track).transform;
        if (!t || t === 'none') return 0;
        // matrix(a,b,c,d,tx,ty) or matrix3d(..., tx, ty, tz)
        if (window.DOMMatrixReadOnly) {
          try {
            return new DOMMatrixReadOnly(t).m41 || 0;
          } catch (_) {}
        }
        const m = t.match(/matrix\(([^)]+)\)/);
        if (m) {
          const parts = m[1].split(',').map((x) => parseFloat(x.trim()));
          return parts.length >= 6 ? (parts[4] || 0) : 0;
        }
        const m3 = t.match(/matrix3d\(([^)]+)\)/);
        if (m3) {
          const parts = m3[1].split(',').map((x) => parseFloat(x.trim()));
          return parts.length >= 16 ? (parts[12] || 0) : 0;
        }
        return 0;
      };

      track.addEventListener('touchstart', (e) => {
        const t = e.touches?.[0];
        if (!t) return;
        // If we just crossed a loop edge, we might be sitting on a clone until the transition ends.
        // Snap/teleport immediately so the next swipe starts from a stable real index.
        snapSilently();
        startX = t.clientX;
        startY = t.clientY;
        startT = performance.now();
        lastX = startX;
        lastT = startT;
        velocityX = 0;
        // Use the actual current transform as the baseline (handles rapid successive swipes).
        baseX = getCurrentTranslateX();
        dragging = true;
        locked = null;
        moved = false;
        clearAnimationState();
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        const t = e.touches?.[0];
        if (!t) return;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        if (locked === null) {
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (locked === 'x') revealAllDots(); // reveal only on real horizontal swipe
        }
        if (locked === 'x') {
          moved = true;
          // Prevent page scroll fighting horizontal drag.
          e.preventDefault();

          const now = performance.now();
          const dt = Math.max(1, now - lastT);
          velocityX = (t.clientX - lastX) / dt; // px/ms (instant)
          lastX = t.clientX;
          lastT = now;

          pendingX = baseX + dx;
          if (!raf) {
            raf = requestAnimationFrame(() => {
              raf = 0;
              setXPixels(pendingX);
            });
          }
        }
      }, { passive: false });

      const release = (endX) => {
        if (!dragging) return;
        dragging = false;
        if (locked !== 'x') return;
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
        const w = slideWidth();
        const dx = endX - startX;
        // Luxury rule: any intentional horizontal swipe advances exactly one slide.
        // Keep the threshold small so a light swipe still moves next/back.
        const threshold = Math.min(18, w * 0.08);
        if (Math.abs(dx) >= threshold) {
          goBy(dx < 0 ? 1 : -1);
        } else {
          goTo(currentIndex);
        }

        if (moved) {
          const blocker = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
          track.addEventListener('click', blocker, { capture: true, once: true });
          setTimeout(() => track.removeEventListener('click', blocker, { capture: true }), 350);
        }
      };

      track.addEventListener('touchend', (e) => release(e.changedTouches?.[0]?.clientX ?? startX), { passive: true });
      track.addEventListener('touchcancel', (e) => release(e.changedTouches?.[0]?.clientX ?? startX), { passive: true });
    }
  }

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        n.querySelectorAll?.('.product-card__swipe-track')?.forEach(initTrack);
        if (n.classList?.contains('product-card__swipe-track')) initTrack(n);
      }
    }
  });

  document.querySelectorAll('.product-card__swipe-track').forEach(initTrack);

  const swipePrimeIO =
    typeof IntersectionObserver !== 'undefined'
      ? new IntersectionObserver(
          (entries) => {
            for (const ent of entries) {
              if (!ent.isIntersecting) continue;
              const fig = ent.target;
              if (fig.dataset.tmrSwipeViewPrimed) continue;
              fig.dataset.tmrSwipeViewPrimed = '1';
              const tr = fig.querySelector('.product-card__swipe-track');
              if (tr) void window.__tmrPrimeSwipeTrackImages?.(tr);
            }
          },
          { root: null, rootMargin: '420px 0px 420px 0px', threshold: 0.01 }
        )
      : null;

  const observeSwipeFigures = () => {
    if (!swipePrimeIO) return;
    document.querySelectorAll('.product-card__figure').forEach((fig) => {
      if (!fig.querySelector('.product-card__swipe')) return;
      if (fig.dataset.tmrSwipeIoBound) return;
      fig.dataset.tmrSwipeIoBound = '1';
      swipePrimeIO.observe(fig);
    });
  };
  observeSwipeFigures();

  const obs2 = new MutationObserver(() => observeSwipeFigures());
  obs2.observe(document.body, { childList: true, subtree: true });

  obs.observe(document.body, { childList: true, subtree: true });

  window.__tmrInitPlpSwipeTrack = initTrack;

  window.__tmrSyncPlpSwipeDots = (swipe) => {
    if (!swipe || !isCoarsePointer()) return;
    const dots = swipe.querySelectorAll('.product-card__dot');
    if (dots.length <= 4) return;
    const revealed = swipe.dataset.tmrDotsRevealed === '1';
    dots.forEach((d, i) => {
      d.hidden = revealed ? false : i >= 4;
    });
  };
})();
